import BarSettings from './Bar';
export default BarSettings;